module.exports = ["Harry Potter Fangirl","Robotics Enthusiast","Dancing Queen","Stranger Things Fan","Adorer of Puppies","Dual Citizen","Lucid Dreamer","<3's all things geometric"]


//////////////////
// WEBPACK FOOTER
// ./src/data/funFacts.json
// module id = AO6l
// module chunks = 1